import { useEffect, useState } from "react";
import axios from "axios";
import { Headphones, ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Quiet "latest episode" ticker.
 * Pulls the most recent Born to Create episode from the RSS feed via /api/podcast/latest.
 * Renders nothing if the feed is unavailable. Editorial, not loud.
 */
export default function LatestEpisodeTicker() {
  const [ep, setEp] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/podcast/latest`)
      .then((res) => {
        if (active && res.data?.available) setEp(res.data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!ep) return null;

  const label = ep.episode_number
    ? `Latest on Born to Create · #${ep.episode_number}`
    : "Latest on Born to Create";

  return (
    <a
      href={ep.link || "/born-to-create"}
      target={ep.link ? "_blank" : undefined}
      rel={ep.link ? "noopener noreferrer" : undefined}
      data-testid="latest-episode-ticker"
      className="group inline-flex items-center gap-3 border border-[#E5E0D8] bg-[#FFFFFF] hover:border-[#1FA5B8] transition-colors pl-2 pr-4 py-2 max-w-full"
    >
      <span className="inline-flex items-center justify-center h-7 w-7 bg-[#1FA5B8] text-[#F7F5F2]">
        <Headphones size={13} strokeWidth={1.6} />
      </span>
      <span className="flex items-baseline gap-2 min-w-0">
        <span className="text-[10px] uppercase tracking-[0.28em] text-[#5C5C5C] font-body whitespace-nowrap">
          {label}
        </span>
        <span className="font-body text-[13px] text-[#1A1A1A] truncate max-w-[42ch] hidden sm:inline">
          {ep.short_title}
        </span>
      </span>
      <ArrowUpRight
        size={14}
        strokeWidth={1.6}
        className="text-[#5C5C5C] group-hover:text-[#1FA5B8] transition-colors shrink-0"
      />
    </a>
  );
}
